import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VideoCallModal from './VideoCallModal';
import Button from '../common/Button'; // Importando o botão genérico
import './VideoCallButton.css';
import { connect } from 'twilio-video';

const VideoCallButton = ({ patient }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [token, setToken] = useState('');
  const [room, setRoom] = useState(null);

  const handleVideoCall = async () => {
    try {
      // Use o token fornecido diretamente para teste
      const token =
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTSzczMjViMGUwZTk2YTZkZGQ5OGNhM2M5ZDdkMGI0MjJmLTE3MjQ4OTUyNjIiLCJncmFudHMiOnsiaWRlbnRpdHkiOiJPaFUzN3VITjJIWDVnbDd6Rk5jU2l3QTd3T0YzIiwidmlkZW8iOnsicm9vbSI6ImRlZmF1bHQtcm9vbSJ9fSwiaWF0IjoxNzI0ODk1MjYyLCJleHAiOjE3MjQ4OTg4NjIsImlzcyI6IlNLNzMyNWIwZTBlOTZhNmRkZDk4Y2EzYzlkN2QwYjQyMmYiLCJzdWIiOiJBQzExOTQxZDljZDMzYjM5ZGU0MTJmN2ZlNDdhMWMwNGUwIn0.NMCUID0W1GL_p95aLA9EScj1oHz_6FhpMh96kbATHWg';

      console.log('Token recebido diretamente:', token);

      setToken(token);
      setModalVisible(true);

      // Conectar à sala do Twilio
      const room = await connect(token, { name: patient.roomName });
      setRoom(room);
    } catch (error) {
      console.error('Erro ao iniciar videochamada:', error);
    }
  };

  useEffect(() => {
    return () => {
      if (room) {
        room.disconnect();
      }
    };
  }, [room]);

  return (
    <div className="video-call-container">
      {/* Substituindo o botão padrão pelo componente Button genérico */}
      <Button
        type="entrar"
        label={`Iniciar Videochamada`}
        onClick={handleVideoCall}
        className="video-call-button" // Classe para aplicar estilos adicionais, se necessário
        ariaLabel={`Iniciar videochamada`}
      />
      <VideoCallModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        token={token}
      />
    </div>
  );
};

VideoCallButton.propTypes = {
  patient: PropTypes.object.isRequired,
};

export default VideoCallButton;
